// Bulk "Upload Projects" — docs/real-estate/be/10-api-reference.md §A14,
// rules in 12-import.md. One .xlsx workbook per upload; jobs of an account
// run one at a time, so a new upload can sit in `queued` for a while.
import { request } from './http';

// Returns { job_id, status: 'queued' } — poll getImportJob(job_id).
// `mode`: 'merge' (add / update only) or 'replace' (also deletes whatever
// the workbook doesn't list — docs/real-estate/be/13-fe-update-2026-09-30.md
// §3).
export function startImport(file, mode = 'merge') {
  const form = new FormData();
  form.append('file', file);
  form.append('mode', mode);
  return request({
    method: 'post',
    path: '/properties/import',
    data: form,
    isMultipart: true,
  });
}

export function getImportJob(jobId) {
  return request({ path: `/properties/import/${jobId}` });
}

// Import history, newest first: { page, page_size, total, results }.
// List items carry counts but no per-row results — use getImportJob.
export function listImportJobs({ page = 1, pageSize = 10, status } = {}) {
  return request({
    path: '/properties/import',
    params: { page, page_size: pageSize, status: status || undefined },
  });
}

// The .xlsx template as a Blob (response .data).
export function getImportTemplate() {
  return request({ path: '/properties/import/template', responseType: 'blob' });
}

// The workbook a job was started with, as a Blob (response .data). The API
// sends the bytes directly; the proxy drops the filename header, so callers
// name the download from the job's `file_name`. 404 when it's no longer
// stored (older jobs from before files were kept).
export function getImportFile(jobId) {
  return request({
    path: `/properties/import/${jobId}/file`,
    responseType: 'blob',
  });
}
